import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import Wrapper from '../layouts/Wrapper';
import Banner from '../components/laboratory/Banner';
import SectionsInfo from '../components/SectionsInfo';
import CustomAccordion from '../components/laboratory/CustomAccordion';
import Spinner from '../components/Spinner';
import { data as mockData } from '../utils/comprehensive-studies-data';
import bannerImage from '../assets/images/comprehensive.jpg';
import { getComprehensivePage } from '../store/actions/comprehensivePage';

function ComprehensiveStudies() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.comprehensivePage);
  useEffect(() => {
    dispatch(getComprehensivePage());
  }, []);
  return (
    <Wrapper>
      <>
        <Helmet>
          <title>
            {mockData[`title_${lang}`]}
          </title>
        </Helmet>
        <div className="container medium">
          <Banner
            title={mockData[`title_${lang}`]}
            description={mockData[`description_${lang}`]}
            bannerImage={bannerImage}
          />
          <div className="rooms_content">
            <SectionsInfo
              isSlider={false}
              isPartner={false}
              title={mockData[`info_${lang}`]}
            />
            {!loading ? (
              <CustomAccordion isFull data={[data.data]} room="laboratories" />
            ) : <Spinner width={100} height={100} />}
          </div>
        </div>

      </>
    </Wrapper>
  );
}

export default ComprehensiveStudies;
